// src/components/Footer.js
import React from 'react';

function Footer({ companyName }) {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-slate-800 text-gray-400 py-8">
      <div className="container mx-auto px-6 text-center">
        <p>&copy; {currentYear} {companyName}. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
